import * as S from './select-helpertext.styles'

import { Icon, type TIconProps } from '~/components/icon'

import type { IconName } from '@raiadrogasil/pulso-icons'

import { DISPLAY_NAME, useSelectContext } from '../../input-select'

import type { ScopedProps } from '../../input-select.types'

type SelectHelperTextProps = React.ComponentPropsWithoutRef<
  typeof S.HelperText
> & {
  leftIcon?: IconName
}

export const HELPER_TEXT_HEIGHT = 20

function SelectHelperText(props: SelectHelperTextProps) {
  const { __scopeSelect, leftIcon, ...rest } =
    props as ScopedProps<SelectHelperTextProps>

  const accessibilityLabel = rest.children?.toString()

  const helperTextDefaultProps = {
    ellipsizeMode: 'tail',
    numberOfLines: 2,
    allowFontScaling: true,
    accessibilityLabel,
  } satisfies Omit<SelectHelperTextProps, 'leftIcon'>

  const { isDisabled, isReadOnly, isError } = useSelectContext(
    DISPLAY_NAME,
    __scopeSelect
  )

  const helperTextStates = {
    isDisabled,
    isReadOnly,
    isError,
  }
  const isLeftIcon = (leftIcon && leftIcon.toString() !== 'empty') || isError
  return (
    <S.HelperTextContainer>
      {isLeftIcon && (
        <Icon
          symbol={isError ? 'rdicon-warning-circle' : leftIcon}
          size="tiny"
          color={getHelperTextSymbolColor(isDisabled, isReadOnly, isError)}
          testID="left-icon-helper-text"
        />
      )}
      <S.HelperText
        {...props}
        {...helperTextDefaultProps}
        {...helperTextStates}
      />
    </S.HelperTextContainer>
  )
}

function getHelperTextSymbolColor(
  isDisabled?: boolean,
  isReadOnly?: boolean,
  isError?: boolean
): TIconProps['color'] {
  if (isError && !isDisabled && !isReadOnly) return 'colorTextDangerAlternative'

  if (isDisabled && !isReadOnly) return 'colorTextNeutralDisabled'
  if (isReadOnly && !isDisabled) return 'colorTextNeutralReadonly'

  return 'colorTextNeutralAlternative'
}

export { SelectHelperText }
